(function (Drupal, $) {
  Drupal.behaviors.socialScroll = {
    attach: function (context) {
      $(document).ready(function () {
        var scrollBlock = $("#social-scroll-block");
        $(document).on("scroll", function () {
          if (scrollBlock.offset().top > $(window).height()) {
            scrollBlock.addClass("active");
          } else {
            scrollBlock.removeClass("active");
          }
        });
      });
    },
  };
})(Drupal, jQuery);
